import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles,grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { arrowBack } from '../../utilities/icons';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInLocationsBase } from '../Utilities/AllInLocationsBase';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';

export class AllInLocationsManager extends AllInLocationsBase(AllInSessionStorage(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        ...super.properties,
        currentOrg: {type: String, reflect:true},
        panel: {type: String, reflect:true},
        name: { type: String },
        view: { type: String },
        _locations: { state:true,type: Array },
        _loading: { state:true,type: Boolean },
    }

    constructor() {
        super();
    }

    async connectedCallback() {
        super.connectedCallback();
        this.eventManager.initHistory({panel:this.panel??'',view:this.view??''});
        if(!this.currentOrg){
            this._loading = true;
        }
        this.organisation = this._getOrganisationById(this.currentOrg);
        if(this.organisation&&!this.organisation?.locations){
            this._maybeGetLocationsFromSessionStorage();
            if(!this.organisation?.locations||this.organisation.locations.length==0){
                await this._fetchLocations();
            }
            else{
                this._fetchLocations();
            }
        }
        if(this.panel){
            this._showPanel(this.panel,this.view);
        }
        this.renderRoot.querySelector('button,a')?.focus();
        this.partial = false;
        const urlParams = new URLSearchParams(window.location.search);
        const partial = urlParams.get('success');
        if(partial&&partial=='partial'){
            this.partial = true;
            let url = new URL(window.location.href);
            url.searchParams.delete('success');
            window.history.replaceState({}, '', url);
        }
        cardLinks(this.shadowRoot);
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    updated(changedProperties){
        if(changedProperties.has('currentOrg')){
            this.organisation = this._getOrganisationById(this.currentOrg);
            this._loading=false;
        }
        if(changedProperties.has('panel')||changedProperties.has('view')){
            if(this.panel){
                this._showPanel(this.panel,this.view);
            }
            this.renderRoot.querySelector('button,a')?.focus();
        }
        cardLinks(this.shadowRoot);
    }

    render() {
        
        let main='';
        if(this._loading){
            main = html`<allin-loader loading></allin-loader>`;
        }
        else{
            let button = html`<button class="back" @click=${this._hidePanel}><span aria-hidden="true">${arrowBack}</span>${msg(str`Return to all locations`)}</button>`;
            let message = '';
            if(this.partial){
                message = html`<p class="error">${msg(str`Location added successfully, but there were some issues with your provisions. Please check your location`)}</p>`;
            }
            if(this.panel=='add'){
                let firstLoc = this.organisation.locations.length==1;
                let str = firstLoc?'&firstloc=true':'';
                window.location.href = '/organisation-dashboard/add-location?org_id='+this.currentOrg+'&addnew=true'+str;
            }
            else if(this.panel=='continue'){
                window.location.href = '/organisation-dashboard/add-location?org_id='+this.currentOrg;
            }
            else if(this.panel){
                main=html`
                    ${button}
                    
                    <allin-organisation-location-form currentOrg=${this.currentOrg}></allin-organisation-location-form>
                `;
            }
            else{
                main=html`
                    ${message}
                    <allin-organisation-locations></allin-organisation-locations>
                `;
            }
        }
        return html`${main}`;
    }

    _showPanel(panel,view){
        this.panel = panel;
        let name = '';
        if(this.panel=='new'){
            name = 'New Location';
        }
        else if (this.panel&&this.panel.includes('zone_'))
        {
            let ids= this.panel.split('_');
            let zoneId = ids[1];
            let locationId = ids[2];
            panel = `${locationId}/zone/${zoneId}`;
        }
        else{

            this.location= this._getLocationById(this.panel);
            if(this.location){
                name = this.location.name;
            }
            else{
                name = 'Location';
            }
        }
        if(view){
            panel+=`/${view}`;
        }
        this.eventManager.emit(`allin-organisation-${this.name}-update`,{location:this.location});
        let crumb = {
            organisation:{url:`/organisation-dashboard/${this.currentOrg}`,title:msg(str`${this.organisation.name}`)},
            dashboard:{url:`/organisation-dashboard/${this.currentOrg}/locations`,title:msg(str`Locations`)},
            
        }
        if(this.panel){
            crumb.panel = {url:`/organisation-dashboard/${this.currentOrg}/locations/${panel}`,title:name};
        }
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        //this.eventManager.emit(`allin-breadcrumb-${this.name}`,{crumb:{url:`/organisation-dashboard/${this.currentOrg}/locations/${panel}`,title:name}});
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/locations/'+panel,{panel:this.panel});
    }

    _hidePanel(){
        this.panel = '';
         let crumb = {
            organisation:{url:`/organisation-dashboard/${this.currentOrg}`,title:msg(str`${this.organisation.name}`)},
            dashboard:{url:`/organisation-dashboard/${this.currentOrg}/locations`,title:msg(str`Locations`)},
        }
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,{back:1});
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/settings',{panel:''});

        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'locations',panel:``});
        this.partial = false;
    }

    _handleContextUpdate(value){
        super._handleContextUpdate(value);
        let prevPanel = this.panel;
        if(this.panel&&this.panel!=prevPanel){
            this._showPanel(this.panel,this.view);
        }
    }

   

    static styles = [
        accessibility,
        formStyles,
        grid,
        css`
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }


        h3,p{
            margin:0;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }

        `
        ];
}